<template>
  <div class="position-relative">
    <div v-if="deActive" class="mt-10 pt-15 px-0 float-left">
      <extra-buttons/>
    </div>

    <div>
      <agency-category ref="category" :edit="false" :fields="fields" :multiAdsCat="false" :page-name="namePage"
                       :phone="this.schema.advertise.contact.phone" @category-schema="getSchema"
                       @category-fields="getFields" @category-current="getCurrent"/>

      <v-col v-if="!auto_change" class="mx-auto" cols="12" lg="6" md="8">
        <city-selector ref="city" :force="true"/>

        <get-panels-number ref="number" :multiple-numbers="false" panel-type="divar_real_estate"/>

        <pic-selector :count="10"/>
      </v-col>

      <input-maker ref="inputs" :fields="this.fields" :param="schema.advertise" :ui_schema="this.ui_schema"/>

      <setting-ads v-if="!auto_change" :market="true" class="mt-0 py-0 my-0"/>

      <div v-if="!auto_change" class="col-md-8 mr-auto">
        <v-btn :loading="loading" class="btn submit-btn float-left" @click="authenticate">
          <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
          ثبت آگهی
        </v-btn>
      </div>
    </div>

  </div>
</template>

<script>
import CitySelector from "@/view/pages/ads/citySelector";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import NumberSelector from "@/view/pages/ads/numberSelector";
import AdsSelector from "@/view/pages/ads/adsSelector";
import InputMaker from "@/view/pages/ads/inputMaker";
import SettingAds from "@/view/pages/ads/settingAds";
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import {Bus} from "@/main";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import PublicButton from "@/view/pages/uiBeautifier/buttonTempl";
import ExtraButtons from "@/view/pages/uiBeautifier/extraButtons";
import AgencyCategory from "./agencyCategory";
import GetPanelsNumber from "./getPanelsNumber";
import ForRent from "../../forRent";

export default {
  name: "agency",
  components: {
    ForRent,
    GetPanelsNumber,
    AgencyCategory,
    ExtraButtons,
    PublicButton,
    ButtonTempl,
    PicSelector,
    SettingAds,
    InputMaker,
    AdsSelector,
    NumberSelector,
    Automatics,
    CitySelector,
  },
  props: {
    ui_schema: {
      type: Array,
      default() {
        return []
      }
    },
    auto_change: {
      default: false
    },
    deActive: {
      default: false
    },
  },
  data() {
    return {
      picker: '',
      submitMessage: '',
      namePage: this.pageName,
      current: '',
      isNational: false,
      fields: [],
      loading: false,
      schema: {
        advertise: {
          category: "",
          location: {
            city: "",
            neighborhood: ""
          },
          images: [],
          contact: {
            chat_enabled: true,
            hide_phone: false,
            phone: null
          },
        },
        available_at: '',
        expire_at: '',
        auto_pay: '',
      }
    }
  },
  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    getCurrent: function (value) {
      this.current = value;
    },
    authenticate() {
      this.$modal.showLoading();

      this.loading = true
      $.ajax({
        url: `${url}/divar/check/title`,
        type: "POST",
        fn: this.authenticate,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-type": 'application/json'
        },
        data: JSON.stringify({
          "title": this.schema.advertise['title'],
          "city": String(this.schema.advertise.location.city),
          "category": this.schema.advertise.category
        }),
        msg: false,
        error: (data) => {
          this.loading = false
          if (data.status === 422) {
            this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
          } else {
            this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
          }

        },
        success: (data) => {
          this.$nextTick(function () {
            this.$modal.success(data.message);
          });
          this.sendAds();
          this.loading = false
        }
      });

    },
    sendAds() {
      const data = this.schema;

      if (!this.$refs.inputs.validate() || !this.$refs.number.validate() || !this.$refs.city.validate())
        return;

      if (data.available_at === "") {
        delete data.available_at;
      }

      if (data.expire_at === "") {
        delete data.expire_at;
      }
      if (data.advertise.location.neighborhood === "" || data.advertise.location.neighborhood === null || data.advertise.location.neighborhood === undefined)
        delete data.advertise.location.neighborhood;
      this.$modal.showLoading();
      $.ajax({
        url: `${url}/divar/agency/send`,
        method: 'POST',
        fn: this.sendAds,
        headers: {
          AUTHORIZATION: Token,
          'Content-Type': 'application/json',
          ACCEPT: 'application/json'
        },
        data: JSON.stringify(data),
        msg: true,
        redirect: {path: '/adsList/myAdsList'}
      });
    },
  },
  mounted() {
    Bus.$on('cityInfo', (value) => {
      this.schema.advertise.location.city = value.city;
      if (value.neighborhood === '')
        delete this.schema.advertise.location.neighborhood
      else
        this.schema.advertise.location.neighborhood = value.neighborhood;
    });

    Bus.$on('category-current', (current) => {
      this.schema.advertise.category = current;
    });

    Bus.$on('rents', (value) => {
      this.schema.advertise['transformable_price'] = value;
    });


    Bus.$on('contact', (value) => {
      this.schema.advertise.contact.chat_enabled = value.chat_enabled;
      this.schema.advertise.contact.hide_phone = value.hide_phone;
      this.schema.auto_pay = value.autoPay;
    });

    Bus.$on('selected_numbers', (value) => {
      this.schema.advertise.contact.phone = value
    });

    Bus.$on('selectedImage', (value) => {
      this.schema.advertise.images = value;
    });

    Bus.$on('reload', (fields) => {
      this.fields = fields;
    });

    Bus.$on('times', (value) => {
      this.schema.available_at = value.times.starttime;
      this.schema.expire_at = value.times.endtime;
    });

    Bus.$on('national', (value) => {
      this.isNational = value
    });

    this.$route.meta.has_ribbon = (!this.auto_change && this.deActive);
  }
}
</script>

<style scoped>


</style>